module.exports = __webpack_public_path__ + "static/media/occasions-convenience.d00fff30.jpg";